import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const Roles = lazy(() => import('./roles/roles.component'));
const Permissions = lazy(() => import('./permissions/permissions.component'));

export function ApplicationAuthorizationRoutes() {
    return (
        <>
            <Route path='authorization'>
                <Route
                    path='roles'
                    element={<Roles />}
                />
                <Route
                    path='permissions'
                    element={<Permissions />}
                />
            </Route>
            <Route
                path='users/roles'
                element={
                    <Navigate
                        to='/authorization/roles'
                        replace
                    />
                }
            />
        </>
    );
}
